

import { Vue, prop, Options } from "vue-class-component";
import { KulionerOrder } from '@/domain/entities/Kulioner';
import { convertArrayToString, formatPriceRP, parsingErrorResponse } from '@/app/infrastructures/misc/Utils';
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import JsBarcode from "jsbarcode";
import { AccountController } from "@/app/ui/controllers/AccountController";
import generateThermalPDF from "@/app/ui/views/shipment/bulk-print-resi/modules/bulk-label-resi-thermal";
import generatePrintReceipt from "./receipt";
import ModalProcessKulioner from "./ModalProcessKulioner.vue";
import { KulionerController } from '@/app/ui/controllers/KulionerController';
import { PrintDataEntitas } from '@/domain/entities/Booking';

class Props {
  selected = prop<KulionerOrder[]>({
    default: () => [],
    type: Array
  });
  status = prop<string>({
    default: "",
    type: String
  });
}

@Options({
  components: {
    ModalProcessKulioner,
  }
})
export default class FooterListKulioner extends Vue.with(Props) {
  isOpenConfirmOrderModal = false;
  get totalPrice() {
    const totalPrice = this.selected.reduce((acc, curr) => {
      return acc + curr.koTotalPrice
    }, 0)

    return formatPriceRP(totalPrice);
  }

  get totalMerchant() {
    const merchantNames = this.selected.map(order => order.koMerchantName);

    return [...new Set(merchantNames)].length;
  }

  get isShowPrintReceipt() {
    return ["ORDBKD", "ORDDLV", "ORDRCV"].includes(this.status.toUpperCase());
  }

  get isShowAcceptOrder() {
    return this.status.toUpperCase() === "ORDWTC"
  }

  get acceptOrderButtonText() {
    return `Terima pesanan (${this.selected.length})`;
  }

  get listSttSelected() {
    if (!this.selected.length) {
      return [];
    }
    return this.selected.filter(item => item.koOrderSttNo);
  }

  listStt: PrintDataEntitas[] = [];
  async getDetailStt() {
    try {
      this.listStt = await KulionerController.getListStt({
        page: 1,
        limit: 50,
        destinationCityId: 0,
        userType: "",
        bookedBy: "",
        bookedType: "",
        fromDate: "",
        endDate: "",
        sttNumber: convertArrayToString(this.listSttSelected, "koOrderSttNo")
      })
    } catch (err) {
      MainAppController.showErrorMessage(parsingErrorResponse(err, "Gagal Print resi!"))
      throw err;
    }
  }

  generateDataResi(data: any) {
    return new Promise((resolve, _reject) => {
      this.listStt.forEach((item, index) => {
        if (item) {
          const barcode = document.createElement("img");
          const vendorBarcode = document.createElement("img");
          JsBarcode(barcode, item.sttNo, {
            textAlign: "left",
            displayValue: false,
            fontSize: 16
          });
          if (item.sttVendorRefferenceNo) {
            // vendor ref code
            JsBarcode(vendorBarcode, item.sttVendorRefferenceNo, {
              textAlign: "left",
              displayValue: false,
              fontSize: 16
            });
          }

          item.sttPieces.forEach(e => {
            data.push({
              ...e,
              ...item,
              barcode: barcode.src,
              vendorRefCode: vendorBarcode.src
            });
          });

          barcode.remove();
          vendorBarcode.remove();
        }

        if (this.listStt.length - 1 === index) {
          resolve(true);
        }
      });
    })
  }

  async printDoc(type: string) {
    const listSttPieces: any = [];

    await this.generateDataResi(listSttPieces);

    if (listSttPieces?.length) {
      new Promise(function(resolve) {
        MainAppController.showLoading();
        setTimeout(resolve.bind(null, null), 1);
      }).then(() => {
        const accountType = AccountController.accountData.account_type;
        if (type === "thermal-pdf") {
          generateThermalPDF(accountType, listSttPieces, [], false);
        }

        MainAppController.closeLoading();
      });
    }
  }

  isLoadingPrintReceipt = false;
  async onPrintReceipt() {
    try {
      MainAppController.showLoading();
      this.isLoadingPrintReceipt = true;
      // TODO: implement print receipt here
      this.listStt = [];
      await this.getDetailStt();
      await this.printDoc("thermal-pdf");
    } catch {
      MainAppController.closeLoading();
    } finally {
      this.isLoadingPrintReceipt = false;
    }
  }

  isLoadingDownloadOrder = false;
  async onPrintOrder() {
    this.isLoadingDownloadOrder = true;
    await generatePrintReceipt(this.selected);
    this.isLoadingDownloadOrder = false;
  }

  onAcceptOrder() {
    // TODO: implement accept order here
    this.isOpenConfirmOrderModal = true;
  }
}
